import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
	breakpoints: {
		values: {
			xs: 0,
			sm: 800,
			md: 1140,
			lg: 1440,
			xl: 1920
		}
	},
	overrides: {
		MuiAppBar: {
			root: {
				background: "#fff"
			}
		},
		MuiButton: {
			root: {
				background: "#fff"
			}
		}
	},
	props: {
		MuiButtonBase: {
			disableRipple: true
		}
	},
	typography: {
		useNextVariants: true,
		fontFamily: "'Source Sans Pro', sans-serif;"
	}
});

export default theme;
